import {
  MembershipActions,
  MembershipActionTypes,
} from '@features/membership/store/actions/membership.actions';
import { HttpError } from '@rd/types';
import { TransferConnectV2CheckoutFormData } from '../../types';
import {
  CheckoutActions,
  CheckoutActionTypes,
} from '../actions/checkout.actions';

export interface CheckoutState {
  loyaltyProgramsFormData: {
    [id: string]: TransferConnectV2CheckoutFormData | null;
  };
  pointsTransfer: {
    loading: boolean;
    error: HttpError | null;
  };
}

const initialState: CheckoutState = {
  loyaltyProgramsFormData: {},
  pointsTransfer: {
    loading: false,
    error: null,
  },
};

export function checkoutReducer(
  state: CheckoutState = initialState,
  action: CheckoutActions | MembershipActions,
): CheckoutState {
  switch (action.type) {
    case CheckoutActionTypes.CLEAR_POINTS_TRANSFER_ERROR:
      return {
        ...state,
        pointsTransfer: {
          ...state.pointsTransfer,
          error: null,
        },
      };
    case CheckoutActionTypes.CLEAR_CHECKOUT_FORM_DATA:
      return {
        ...state,
        loyaltyProgramsFormData: {
          ...state.loyaltyProgramsFormData,
          [action.payload.loyaltyProgramId]: null,
        },
      };
    case CheckoutActionTypes.SUBMIT_CHECKOUT_FORM_DATA:
      return {
        ...state,
        loyaltyProgramsFormData: {
          ...state.loyaltyProgramsFormData,
          [action.payload.loyaltyProgramId]: action.payload.formData,
        },
      };
    case MembershipActionTypes.CREATE_MEMBERSHIP_SUCCESS:
    case MembershipActionTypes.UPDATE_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        // @ts-ignore
        loyaltyProgramsFormData: {
          ...state.loyaltyProgramsFormData,
          [action.payload.loyaltyProgramId]: {
            ...state.loyaltyProgramsFormData[action.payload.loyaltyProgramId],
            membershipId: action.payload.id,
          },
        },
      };
    case CheckoutActionTypes.SUBMIT_POINTS_TRANSFER:
      return {
        ...state,
        pointsTransfer: {
          ...state.pointsTransfer,
          loading: true,
        },
      };
    case CheckoutActionTypes.SUBMIT_POINTS_TRANSFER_FAIL:
      return {
        ...state,
        pointsTransfer: {
          ...state.pointsTransfer,
          loading: false,
          error: action.payload,
        },
      };
    case CheckoutActionTypes.SUBMIT_POINTS_TRANSFER_SUCCESS:
      return {
        ...state,
        pointsTransfer: {
          ...state.pointsTransfer,
          loading: false,
          error: null,
        },
      };

    case CheckoutActionTypes.HYDRATE_POINTS_TRANSFER_REDEMPTION:
      const { targetAmount, sourceAmount, membershipId, loyaltyProgramId } =
        action.payload.pointsTransferHydrationState.data;
      return {
        ...state,
        loyaltyProgramsFormData: {
          ...state.loyaltyProgramsFormData,
          [loyaltyProgramId]: {
            membershipId,
            targetAmount,
            sourceAmount,
          },
        },
      };
  }

  return state;
}
